
import { useState, useEffect } from 'react';
import { UpdateFormData, AutomatedUpdate } from './types';

export const useUpdateForm = (setIsDialogOpen: (open: boolean) => void) => {
  const [editingId, setEditingId] = useState<number | null>(null);
  const [formData, setFormData] = useState<UpdateFormData>({
    country: '',
    league: '',
    season: '',
    excel_url: '',
    update_frequency: 'weekly',
    admin_email: ''
  });

  const resetForm = () => {
    setFormData({
      country: '',
      league: '',
      season: '',
      excel_url: '',
      update_frequency: 'weekly',
      admin_email: ''
    });
    setEditingId(null);
  };

  const handleEdit = (update: AutomatedUpdate) => {
    setEditingId(update.id);
    setFormData({
      country: update.country,
      league: update.league,
      season: update.season,
      excel_url: update.excel_url,
      update_frequency: update.update_frequency,
      admin_email: update.admin_email || ''
    });
    setIsDialogOpen(true);
  };

  useEffect(() => {
    if (!setIsDialogOpen) return;
    
  }, [setIsDialogOpen]);

  return {
    editingId,
    setEditingId,
    formData,
    setFormData,
    resetForm,
    handleEdit
  };
};
